import React, { useEffect, useState } from "react";
import AuthLayout from "pages/auth/authlayout/authlayout";
import { ERCText } from "components/text";
import ERCInput from "components/Input";
import { MdOutlineErrorOutline } from "react-icons/md";
import { ERCForm } from "components/form";
import { useDispatch } from "react-redux";
import { showModal } from "store/reducers/modal";
import ForgotPasswordModal from "components/modal/forgotpassword";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { setUser } from "store/reducers/user";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const Login = ({ userType, navigateTo }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const schema = Yup.object().shape({
    emailPhone: Yup.string().required(),
    password: Yup.string().required().min(8),
  });

  const [registerPage, setRegisterPage] = useState(null);

  useEffect(() => {
    const pathMap = {
      "/login-guest": "/signup-guest",
      "/login-student": "/signup-student",
      "/login-counsellor": "/signup-counsellor",
      "/login-teacher": "/signup-teacher",
      "/store-login-student": "/signup-student",
    };
    setRegisterPage(pathMap[location.pathname] || null);
  }, [location.pathname]);

  const handleSignUp = () => {
    if (registerPage) {
      navigate(registerPage);
    }
  };

  return (
    <AuthLayout>
      <div className="flex flex-col items-center justify-center w-full bg-white rounded-xl px-6 py-8 sm:px-12 sm:py-10 lg:px-24 lg:py-12">
        {/* Logo */}
        <div className="flex justify-center items-center">
          <img
            src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1716814039/ERC/erc_main_logo_nbljik.svg"
            alt="logo"
            className="w-[150px] md:w-[180px]"
          />
        </div>

        {/* Welcome Text */}
        <div className="flex flex-col py-4 items-center gap-8 w-full text-center ">
          <ERCText weight="700" size="30px">
            Welcome Back!
          </ERCText>
          <div className="flex  items-center gap-2 px-4 py-2 bg-yellow-100 rounded-lg w-full">
            <MdOutlineErrorOutline size={20} className="text-primary" />
            <ERCText size="12px">
              Continue your{" "}
              <span className="text-primary font-semibold">Learning.</span>{" "}
              Enter your registered information.
            </ERCText>
          </div>
        </div>

        {/* Login Form */}
        <ERCForm
          extraFields={{ userType }}
          validationSchema={schema}
          inputsContainer="w-full max-w-md flex flex-col gap-6"
          className="w-full flex flex-col items-center gap-10"
          btnClass={"!w-[100%] !bg-[#FFD600] !text-[16px] !text-[#00296B]"}
          btnText="Sign In"
          method="post"
          url="/user/login"
          noToken
          onSuccess={(res) => {
            dispatch(setUser(res));
            navigate(navigateTo);
            if (res.data.token) {
              const token = res.data.token;
              const authObj = {
                email: res.data.details.email,
                name: res.data.details.fullName,
                roles: res.data.details.role,
                id: res.data.details.id,
              };
              window.sessionStorage.setItem("auth", JSON.stringify(authObj));
              window.sessionStorage.setItem("token", JSON.stringify(token));
            }
          }}
          onError={(err) => {
            if (err?.response) {
              toast.error("Login details incorrect!");
            }
          }}
        >
          <div className="w-full">
            <ERCInput
              containerClass="w-full"
              label="Email Address"
              name="emailPhone"
              placeholder="Enter your email address"
            />
          </div>
          <div className="w-full ">
            <ERCInput
              containerClass="w-full "
              label="Password"
              name="password"
              type="password"
              placeholder="Enter your password"
            />
          </div>
          <div className="flex justify-end w-full">
            <ERCText
              isLink
              size="16px"
              color="#FFD600"
              className="cursor-pointer"
              onClick={() =>
                dispatch(
                  showModal({
                    content: <ForgotPasswordModal />,
                  })
                )
              }
            >
              Forgot Password?
            </ERCText>
          </div>
        </ERCForm>

        {/* Signup Link */}
        <div className="mt-4">
          <ERCText size="15px" weight="600">
            Don't have an Account?{" "}
            <span
              className="text-primary cursor-pointer"
              onClick={handleSignUp}
            >
              SIGN UP
            </span>
          </ERCText>
        </div>
      </div>
    </AuthLayout>
  );
};

export default Login;
